module.exports = __webpack_public_path__ + "img/no-review-submitted.bcecdcf4.png";